import { call, select, take } from "redux-saga/effects";
import actionTypes from "../../actions/actionTypes";
import { createNewsletterStructure, deleteNewsletterStructure, updateNewsletterBasics, updateNewsletterStructure } from "../../apis/wpApi/apiCalls";
import authUser from "../../apis/wpApi/authUser";
import { putError, putSuccess } from "../helpers";
import { NEWSLETTERSERVER } from "../../constants/state";


const STRUCTURE_ITEMS_BASIC_ATTRIBUTES = [
    'itemType',
    'headlineClient',
    'headlineFront',
    'order'
]

const getStructure = (state, campaignId) => state.getIn([NEWSLETTERSERVER, 'campaigns', 'data', 'items', campaignId, 'structure']).toJS()


function* getData(data, dataAttr) {
    const sanData = yield {}

    if(!data) {
        throw new Error('No data')
    }

    for(let i = 0; i < dataAttr.length; i++) {
        const attr = dataAttr[i]

        if(!data.hasOwnProperty(attr)) {
            throw new Error(`No data attribute "${attr}"`)
        } else {
            sanData[attr] = yield data[attr]
        }
    }

    return yield sanData
}


function* checkResponse(response) {
    if(
        !response || 
        !response.status || 
        200 !== response.status
    ) {
        throw new Error('No data from api')
    }
}

function* getDataFromResponse(response, attributes) {
    yield call(checkResponse, response)

    if(!response.data) {
        throw new Error('No data from api')
    }

    return yield call(getData, response.data, attributes)
}


function* createStructureItem(apiKey, pk, data) {
    const callData = yield call(getData, data, STRUCTURE_ITEMS_BASIC_ATTRIBUTES)
    const response = yield call(createNewsletterStructure, apiKey, {
        ...callData,
        newsletterPk: pk
    })

    yield call(getDataFromResponse, response, [
        ... STRUCTURE_ITEMS_BASIC_ATTRIBUTES,
        'pk',
        'newsletterPk'
    ])
}

function* updateStructureItem(apiKey, data) {
    const dataAttr = yield [...STRUCTURE_ITEMS_BASIC_ATTRIBUTES, 'pk']

    const callData = yield call(getData, data, dataAttr)
    const response = yield call(updateNewsletterStructure, apiKey, callData)

    yield call(getDataFromResponse, response, dataAttr)
}

function* deleteStructureItem(apiKey, data) {
    const callData = yield call(getData, data, ['pk'])
    const response = yield call(deleteNewsletterStructure, apiKey, callData)

    yield call(checkResponse, response)
}

function* updateStructure(apiKey, pk, data) {
    const { structure } = yield data
    const oldStructure = yield select(getStructure, pk)

    const itemsToDelete = yield _.difference(oldStructure.order, structure.order)
    const itemsToCreate = yield _.difference(structure.order, oldStructure.order)
    const itemsToUpdate = yield _.difference(structure.order, itemsToDelete, itemsToCreate)

    for(let i = 0; i < itemsToCreate.length; i++) {
        const data = yield structure.items[itemsToCreate[i]]
        yield call(createStructureItem, apiKey, pk, data)
    }

    for(let i = 0; i < itemsToUpdate.length; i++) {
        const data = yield structure.items[itemsToUpdate[i]]
        yield call(updateStructureItem, apiKey, data)
    }

    for(let i = 0; i < itemsToDelete.length; i++) {
        const data = yield oldStructure.items[itemsToDelete[i]]
        yield call(deleteStructureItem, apiKey, data)
    }
}

function* updateBasics(apiKey, pk, data) {
    const callData = yield call(getData, data, ['name', 'description', 'style', 'order'])
    const response = yield call(updateNewsletterBasics, apiKey, {
        ... callData,
        pk: pk
    })

    return yield call(getDataFromResponse, response, [
        'pk',
        'cinema',
        'name',
        'description',
        'campaigns',
        'style',
        'structure',
        'order'
    ])
}

function* updateCampaign(payload) {
    try {
        const { campaignId, data } = yield payload
        const apiKey = yield call(authUser.getToken)

        yield call(updateStructure, apiKey, campaignId, data)
        const newData = yield call(updateBasics, apiKey, campaignId, data)

        yield call(putSuccess,actionTypes.NEWSLETTER_UPDATE_CAMPAIGN_SUCCESS, newData)
    } catch(e) {
        yield console.log('e', e)
        yield call(putError,actionTypes.NEWSLETTER_UPDATE_CAMPAIGN_ERROR, e.message)
    }
}

function* watchCompaignUpdateRequest() {
    try {
        while(true) {
            const request = yield take(actionTypes.NEWSLETTER_UPDATE_CAMPAIGN_REQUEST)

            yield call(updateCampaign, request.payload)
        }

    } catch(e) {
        console.log('error!!!!!', e.message)
    }
}


export default watchCompaignUpdateRequest;